/*
We will create ActionCreators which are functions that return action objects with two parameters :- 

type : Used to identify the type of action we are sending. It is also used to differentiate between multiple actions. 
payload : Used to hold any data that might be required to accompany the object.

*/
import CalCalDataApi from '../../api/CalCalDataApi';
import LocalStorage from '../../api/LocalStorage';

/*
export function listIsLoading(bool: boolean) {
	return {
		type: "CUSTOMERS_IS_LOADING",
		isLoading: bool,
	};
}
export function fetchListSuccess(list: Object) {
	//this just makes the FETCH_LIST_SUCCESS bit of the reducer return action.list
	return {
		type: "CUSTOMERS_LIST_SUCCESS",
		list,
	};
}

export function setListError(error) {
	//this just makes the FETCH_LIST_SUCCESS bit of the reducer return action.list
	return {
		type: "CUSTOMERS_LIST_ERROR",
		error,
	};
}*/


//THUNK
export function fetchList(peopleType) {
  return function(dispatch, getState) {
	  
	//const authToken = getState().loginReducer.user.access_token;
	const jwt = getState().loginReducer.jwt.token; //expiresd?
	const bigType = peopleType.toUpperCase();
	//console.log('got authToken in actions ', authToken);
    dispatch({type: bigType+"_IS_LOADING", isLoading: true});
	
    CalCalDataApi.dataLoad(peopleType, jwt, res => {
		dispatch({type: bigType+"_IS_LOADING", isLoading: false});
		if (!res.error) {
		  dispatch({
				type: bigType+"_LIST_SUCCESS",
				list: res
		  });
		} else {
			dispatch({
				type: bigType+"_LIST_ERROR",
				error: res.error,
			});
			if(res.error=='Expired token') this.props.dispatch({
				type: 'SET_JWT',
				token: null,
				info: null
			});
		}
	});
  }
}

export function updateCustomerDebt(custId) {
  return function(dispatch, getState) {
	  
	//const authToken = getState().loginReducer.user.access_token;
	const jwt = getState().loginReducer.jwt.token; //expiresd?
	CalCalDataApi.dataLoad('/customers/'+custId, jwt, res => {
		if (!res.error) dispatch({type: "UPDATE/customer", id: custId, difference: res});
	});
  }
}
/*

eg

// Thunk function, it calls the getRepos action above after it receives the fetch response.
export function getRepoThunk() {
  return function(dispatch, getState) {
    fetch('https://api.github.com/repositories')
    .then(e => e.json())
      .then(function(response){
        console.log(response);
        var arr = response.slice(0,10);
        dispatch(getRepos(arr))
      })
      .catch((error) => {
        console.error(error,"ERRRRRORRR");
      });
  }
}
// Repo selected action
export function repoSelected(repo){
  return{
    type: 'Repo_Selected',
    payload: repo
  }
}

*/